import React from 'react';
import FaqAccordion from './FaqAccordion';
import FaqBackgroundText from './FaqBackgroundText';
import FaqHeader from './FaqHeader';
import LandingCopyright from './LandingCopyright';
import styles from './landingFaq.module.css';
import { LANDPAGE_FAQ } from '../../landpage.constants';

const LandingFaqSection: React.FC = () => {
  const copy = LANDPAGE_FAQ;

  return (
    <section className={styles.section}>
      <div className={styles.faqArea}>
        <div className={styles.container}>
          <div className={styles.headerArea}>
            <FaqHeader title={copy.title} />
            <FaqBackgroundText text={copy.backgroundText} />
          </div>
          <FaqAccordion items={copy.items} />
        </div>
      </div>

      <LandingCopyright text={copy.copyright} />
    </section>
  );
};

export default LandingFaqSection;
